import { render, staticRenderFns } from "./OrderPaymentInfoAddress.vue?vue&type=template&id=29bb95c2&"
import script from "./OrderPaymentInfoAddress.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentInfoAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports